import { useGetKadryInfoQuery } from '@shared/api';
import { KADRY_REQUESTS_OPS, kadryErrorMessage, useKadryAccess } from '@entities/kadry';
import { Card } from '@shared/ui/Card';
import { FallbackBanner } from '@shared/ui/FallbackBanner';
import { SkeletonLine } from '@shared/ui/Skeleton';
import { KadryDashboard } from './Overview/KadryDashboard';

/** Обзор модуля: состояние и дашборд подбора. */
export function KadryHome() {
  const { data, isLoading, error } = useGetKadryInfoQuery();
  const { ready, canAny, can } = useKadryAccess();

  if (isLoading) {
    return (
      <Card>
        <SkeletonLine />
        <SkeletonLine />
      </Card>
    );
  }
  if (error || !data) {
    return <FallbackBanner tone="danger" title="Модуль недоступен">{kadryErrorMessage(error)}</FallbackBanner>;
  }

  return (
    <>
      {data.status.state === 'disabled' && (
        <FallbackBanner tone="info" title="Модуль в разработке">
          ОСНОВА.Кадры включается после приёмки всей матрицы испытаний. До этого модуль работает
          только на тестовых данных.
        </FallbackBanner>
      )}
      {data.status.state === 'unavailable' && (
        <FallbackBanner tone="danger" title="Модуль включён, но недоступен">
          {data.status.reason}
        </FallbackBanner>
      )}
      {ready &&
        (canAny(KADRY_REQUESTS_OPS) ? (
          <KadryDashboard admin={can('admin_settings')} />
        ) : (
          <FallbackBanner tone="info" title="Нет доступа к подбору">
            У вашей учётной записи нет ролей в ОСНОВЕ. Обратитесь к администратору.
          </FallbackBanner>
        ))}
    </>
  );
}
